import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, Box } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'

import GraphicalDetails from 'containers/Reporting/Overview/GraphicalDetails'
import MobileDrawer from 'components/Reporting/Overview/MobileDrawer'
import ShareDashboard from 'containers/Reporting/Overview/GraphicalDetails/ShareDashboard'
import Header from 'components/Shared/Header'
import ShowHideButton from 'components/Shared/ShowHideButton'
import { isMobileView } from 'lib/GlobalConstants'
import { setFilters, setFilterVisibility } from 'redux/slices/FilterBuilder'
import { resetQuestions } from 'redux/slices/SignUpQuestions'
import { setActiveGroup } from 'redux/slices/ParticipantGroups'
import { useAppDispatch, useAppSelector } from 'redux/Hook'
import ColorsTheme from 'assets/styles/themes/ColorTheme'

const Dashboard = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    // Reset PRM data
    return () => {
      dispatch(setFilters([]))
      dispatch(resetQuestions())
      dispatch(setActiveGroup(null))
    }
  }, [])
  const {
    features: {
      features: {
        overview_dashboard_sharing: { enabled = false } = {},
        dashboard_filters_visibility: { enabled: filterVisibilty = false } = {},
      } = {},
    } = {},
    filterBuilder: { selectedFilters = [], isFiltersetVisible = false } = {},
  }: any = useAppSelector((state) => state)
  const { t } = useTranslation()
  const drawerProps = [{ component: <ShareDashboard isMobileDrawer={true} /> }]

  const checkifEmptyValue =
    selectedFilters?.filter(
      (item: any) => item.name !== 'dateRange' && item?.value?.length,
    )?.length || 0

  const showHideFilters = () => {
    const alignment = isMobileView ? 'center' : 'end'
    return filterVisibilty ? (
      <Grid
        item
        xs={isMobileView ? 12 : 6}
        justifyContent={alignment}
        textAlign={alignment}
        marginTop={!isMobileView ? '0.625rem' : 0}
      >
        <ThemeProvider theme={ColorsTheme}>
          <ShowHideButton
            disabled={!checkifEmptyValue}
            count={checkifEmptyValue}
            isHidden={isFiltersetVisible}
            onClick={() => dispatch(setFilterVisibility(!isFiltersetVisible))}
          />
        </ThemeProvider>
      </Grid>
    ) : null
  }
  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
      >
        <Grid item>
          <ShareDashboard isMobileDrawer={false} />
        </Grid>
      </Grid>
      <Grid container sx={{ marginTop: isMobileView ? '5.2rem' : 0 }}>
        <Grid container marginTop={enabled && !isMobileView ? '2rem' : 0}>
          <Grid item xs={6}>
            <Box marginBottom="1.5rem">
              <Header title={t('sidebar.home')} />
            </Box>
          </Grid>
          {!isMobileView && showHideFilters()}
          <Grid item xs={6} justifyContent="end" textAlign="end">
            {enabled ? <MobileDrawer drawerProps={drawerProps} /> : null}
          </Grid>
        </Grid>
        {isMobileView && showHideFilters()}
        <GraphicalDetails />
      </Grid>
    </>
  )
}

export default Dashboard
